import { confirm } from "../../../components/Confirm";

export const openPanelDeleteConfirm = async (title) => {
    return confirm({
        icon: true,
        text: `Please confirm deletion of "${title}"? <br/> NOTE: All charts on this panel will also be deleted.`
    });
};